import DepositoUpdate from './DepositoUpdate.vue'
export default DepositoUpdate
